/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('cart.list');

var $ = window.jQuery = require('base'), _api = module.exports, layer = $.Deferred(), qtip_deferred = $.Deferred(), computor_loader = $.Deferred(), number_deferred = $.Deferred();

$.extend(_api, require('../common/com.jufeng.common.header'));
// require.ensure('form_validate', function(){validate.resolve(reuqire('form_validate'))});
require.ensure('layer', function () {
	layer.resolve(require('layer'));
})
require.ensure('qtip2', function () {
	qtip_deferred.resolve(require('qtip2'))
})
require.ensure('util.number', function () {
	number_deferred.resolve(require('util.number'))
})
require('bootstrap-touchspin');

$.when(_api.context, _api.lazyload, layer, qtip_deferred, number_deferred).then(function (context, lazyload, layer, qtip2, number_util) {
	//
	$("#cart_detail")[0].done(function () {
		$('input[data-prop-path$="count"]').each(function () {
			var $this = $(this),
			option = new Function('return ' + $this.data('option'))();
			$this.TouchSpin($.extend({
					initval : 0,
					min : 1,
					max : 0x7FFFFFFF,
					step : 1,
					verticalbuttons : true,
					verticalupclass : 'icon-starry-normal-plus4 j-a-btn-num-up',
					verticaldownclass : 'icon-starry-normal-minus5 j-a-btn-num-down'
				}, option))
		})

		require.ensure('./com.jufeng.computor.loader', function () {
			computor_loader.resolve(require('./com.jufeng.computor.loader'));
		});
		// 必须等页面内容加载完才能绑定事件监听事件
		computor_loader.done(function (computor_loader) {

			$('#carts').on('change keyup', 'div.content_box', function (e, iv, v, direct) {
				var $this = $(this), //
				front_view_type = $this.data('front-view-type'), //
				$detail_price = $(e.target).closest('tr').find('#detail_price'); //
				computor_loader.use(front_view_type || 'item_default').done(function (computor) {
					//
					// 修改购物车记录.
					computor.modify_cart($this, computor.callback, function (err) {
						if (direct === 'up' || e.type === 'keyup') {
							//
							layer.alert(err.responseJSON.msg);
							if (e.type === 'keyup') {
								//
								var _v = $(e.target).val();
								if (_v) {
									$(e.target).val(_v.substr(0, _v.length - 1));
								}
								//
							} else {
								//
								$(e.target).val(iv || 0).attr('value', iv || 0);
							}
						}
					});
				})
			})

			$('#carts').on('click', 'a[data-delete]', function (e) {
				var $this = $(this),
				options = $this.data('delete'),
				front_view_type = $this.closest('div.content_box').data('front-view-type');
				typeof options === 'string' && (options = new Function('return ' + options)());
				computor_loader.use(front_view_type || 'item_default').done(function (computor) {
					// 修改购物车记录.
					computor.delete_cart.call($this, options).done(function (tip) {
						if (tip.result === 'success') {
							window.location.reload();
						} else {
							LOG.error('删除失败');
						}
					});
				})
			})

			$('#carts').on('click', 'a[data-favorite]', function (e) {
				var $this = $(this),
				product_no = $this.data('favorite');
				$.ajax({
					url : '/add2Favorites.htm?product_no=' + product_no + '&opt=add',
					dataType : 'json',
					success : function (tip) {
						if (tip.result === 'success') {
							LOG.info('收藏产品(' + product_no + ')成功.');
						}
						layer.alert(tip.msg, {
							title : '温馨提示',
							icon : tip.result === 'success' ? 1 : 5,
							time : 1500
						})
					}
				})
			})

			$('a.jufeng_cart_btn_submit').click(function () {
				if (!$('#carts').find('div[data-front-view-type]').length) {
					layer.alert('当前购物车里没有任何商品', {
						icon : 5,
						title : '温馨提示',
						btn : ['我要去购物']
					}, function () {
						// 进入首页
						window.location.href = "/"
					})
					return false;
				}

				context.try_login(function () {
					// 找出此时被选中的购物车记录.
					var cartids = $.map($('#carts').find('input[name="ckbox_cart"][type="checkbox"]:checked'), function (e) {
							return $(e).val();
						})
						if (!cartids.length) {
							layer.done(function (layer) {
								layer.alert('您未勾选购物车里商品', {
									icon : 5,
									title : '温馨提示'
								})
							})
							return false;
						}
						LOG.info(cartids.join(','));
					window.location.href = '/submit.htm?cartids=' + cartids.join(',');
				})

			})

			$('a.jufeng_cart_batch_delete').click(function () {
				layer.confirm('您确定要清空购物车吗？', {
					icon : 3,
					title : '确认提示'
				}, function (index, layerpo) {
					layer.close(index);
					$.ajax({
						url : '/clear_cart.htm',
						dataType : 'json',
						success : function () {
							window.location.reload()
						}
					})
				})
			})

			$('#carts').on('change', 'input[name="ckbox_cart"],input.jufeng_cart_sel_all', function () {
				var $this = $(this),
				checked = $this.is(':checked'),
				all = $this.is('.jufeng_cart_sel_all'),
				cartids = [];
				if (all) {
					Array.prototype.push.apply(cartids, $.map($('input[name="ckbox_cart"]', '#carts'), function (e) {
							return $(e).prop('checked', checked).val();
						}))
				} else {
					cartids.push($this.val());
				}
				$.ajax({
					url : '/toggle_cart.htm?flag=' + checked,
					type : 'post',
					contentType : 'application/json',
					data : JSON.stringify(cartids),
					success : function (tip) {
						LOG.info(tip.msg)
					}
				})
			})

		});

		//=========================QTIP2=========================

		/**
		 * 默认的qtip绑定回调函数.
		 */
		function _default_init_qtip_callback() {
			init_qtip();
			// 所有的input且有data-tip的不允许输入非数字
			$('#carts').on('keyup', 'input[data-tip]', function (e) {
				var self = $(this);
				var value = self.val();
				if (/[\D]+/.test(value)) {
					self.trigger({
						type : 'error',
						content : '请输入数字'
					});
					value = value.replace(/[\D]+/, '', 'g');
				}
				self.val(+value || 1);
			})
		}

		function init_qtip(context) {
			$('[data-tip]', context).each(function () {
				var that = $(this);
				var tip_options = that.data('tip');
				var events = $.map(tip_options, function (t, e) {
						return e;
					})
					that.qtip({
						content : function (e, api) {
							var visible_qtips = $('div[id^="qtip-"].qtip:visible').not('#' + api._id);
							if (visible_qtips.length) {
								setTimeout(function () {
									api.toggle(false, e)
								}, 0)
							} else {
								e.focus !== false && $(this).filter('input[type="text"]').focus().select();
							}
							return tip_options[e.type] || e.content;
						},
						show : events.join(' ') + ' error',
						hide : 'keydown blur',
						position : $.extend({
							viewport : $(window),
							target : (tip_options['target'] && $(tip_options['target'])) || true,
							my : 'bottom center',
							at : 'top center',
						}, tip_options['position']),
						style : 'input_tip1'
					})
			})
		}
		//
		_default_init_qtip_callback();

		// ===================================
	});

})

//=============================================

require('../css/bootstrap.css');
require('../css/cat_nav.less');
require('../css/header.less');
require('../css/footer.css');
require('../css/order/order.less');
require('../css/order/table.css');
require('../css/activity.less');
require('../css/floor_right.less');
require('../css/layer.css');
require('../css/jquery.qtip.min.css');
require('../css/product/jquery.bootstrap-touchspin.css');



// WEBPACK FOOTER //
// ./src/main/javascript/cart/com.jufeng.cart.view.js